import axios from 'axios'

export const getShipmentList = (type, currentPage, perPage) => {
  return axios.get(`shipment/list/${type}/${currentPage}/${perPage}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getOtif = ({shipmentId, orderNumber}) => {
  return axios.get(`shipment/otif/${shipmentId}/${orderNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getShipmentDetail = ({shipmentId, orderNumber}) => {
  return axios.get(`shipment/detail/${shipmentId}/${orderNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getShipmentHistory = ({shipmentId, orderNumber}) => {
  return axios.get(`shipment/history/${shipmentId}/${orderNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getShipmentDocument = ({shipmentId, orderNumber}) => {
  return axios.get(`shipment/document/${shipmentId}/${orderNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const downloadShipmentDocument = ({shipmentId, orderNumber, type, fileName, fileCategory, fileId}) => {
  return axios.get(`file/shipment/download/stream/${shipmentId}/${orderNumber}/${fileId}/${fileCategory}/${type}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const uploadShipmentDocument = (formData) => {
  return axios.post('file/shipment/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => res)
    .catch(err => {
      console.log('err', err)
      throw err.response
    })
}

export const getShipmentPrice = ({shipmentId, orderNumber}) => {
  return axios.get(`shipment/price/${shipmentId}/${orderNumber}/ALL`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getShipmentInvoice = (shipmentId) => {
  return axios.get(`shipment/invoice/list/${shipmentId}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const downloadShipmentInvoice = ({shipmentId, orderNumber, invoiceId, fileName}) => {
  return axios.get(`shipment/invoice/${shipmentId}/${orderNumber}/${invoiceId}`, {responseType: 'blob'})
    .then(res => {
      let blob = new Blob([res.data], {type: res.headers['content-type']})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      return res
    })
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const addShipmentRequest = ({shipmentId, orderNumber}) => {
  return axios.put(`shipment/detail/request/${shipmentId}/${orderNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const getLeadtime = ({shipmentId, orderNumber}) => {
  return axios.get(`shipment/leadtime/${shipmentId}/${orderNumber}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err)
      throw err.response
    })
}

export const updateShipmentDetails = ({
  payload, shipmentId, orderNumber, type
}) => axios.put(`shipment/detail/${type}/${shipmentId}/${orderNumber}`, payload)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const downloadPriceDetail = (shipmentId, fileName) => axios.get(`shipment/download/price/${shipmentId}`, { responseType: 'blob' })
  .then((res) => {
    const blob = new Blob([res.data], { type: res.headers['content-type'] })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    return res
  })
  .catch((err) => {
    throw err.response
  })

export const getUser = (type, idShipment) => axios.get(`shipment/${type}/user/${idShipment}`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getDelayLog = (shipmentId, orderNumber) => axios.get(`shipment/otif/delay-log/${shipmentId}/${orderNumber}`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const filterShipment = (page, type, filter, key, perPage) => axios.get(`shipment/filter/${page}/${type}/${filter}/${key}/${perPage}`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const downloadEfbl = async (data) => {
  try {
    const res = await axios.get(`shipment/fbl/download-signed/${data.shipmentFiataId}`, { responseType: 'blob' })
    let blob = new Blob([res.data], { type: res.headers['content-type'] })
    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = data.fileName
    document.body.appendChild(link)
    link.click()
    return res
  } catch (err) {
    console.log('err', err)
    throw err.response
  }
}



// WEBPACK FOOTER //
// ./src/api/shipment.api.js